if (!customElements.get('beeda-tabs')) {
  class BeedaTabs extends HTMLElement {
    constructor() { 
      super();
  
      const tabSelect = this.querySelector('.tab-mobile-nav');
      const tabButtons = this.querySelectorAll('.tab-btn');
      const tabPanels = this.querySelectorAll('.tabs_article');
  
      tabButtons[0].classList.add('active');
      tabPanels[0].classList.add('active');
  
      tabButtons.forEach((button, index) => {
        button.addEventListener('click', () => {
          activateTab(index);
        });
  
        const option = document.createElement('option');
        option.value = button.getAttribute('data-tab-target');
        option.textContent = button.textContent;
        tabSelect.appendChild(option);
      });
  
      tabSelect.addEventListener('change', () => {
        const selectedIndex = tabSelect.selectedIndex;
        activateTab(selectedIndex);
      });
  
      function activateTab(index) {
        tabButtons.forEach((button) => {
          button.classList.remove('active');
        });
        tabPanels.forEach((panel) => {
          panel.classList.remove('active');
        });
  
        tabButtons[index].classList.add('active');
        tabPanels[index].classList.add('active');
        tabSelect.selectedIndex = index;
      }
    }
  }  
  customElements.define('beeda-tabs', BeedaTabs);
}